//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cancel,progress,couponCancel } from '../../model/appointment/appointmentService';
import { getMyDate } from '@/utils/commonUtils'
import { store } from "@/observable/store"
import Txrweb from '@/utils/mixin/mixinTxrweb'

export default {
    name: "reservation-status",
    mixins:[Txrweb],
    data(){
        return {
            uuid:null,
            hospital:{},
            patient:{},
            info:{},
            title:'提交预约',
            status_title:'预约成功',
            status_title_last:'已完成',
            gatCard:process.env.VUE_APP_GAT_CARD,
        }
    },
    computed: {
        refid(){
            return store.refid
        },
        gatCardFlag(){
             return this.$route.query.gatCardFlag
        }
    },
    created() {
        window.scrollTo(0,0);  
        this.uuid = this.$route.query.uuid;
        this.progress()
    },
    mounted() {
       
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.trak(from)
      })
    },
    methods: {
      trak(source){
        // 埋点
          this.STATISTICS('load','sybao_ins_appointment_result_page',{source:source.path})
          if( source.path =='/reservationServe'){
             this.subscribeTX()
          }
        },
        mapClick(){
            //console.log(this.hospital.longitude)
            this.$router.push({
                path: "/map",
                query:{
                    lng:this.hospital.longitude,
                    lat: this.hospital.latitude
                }
            });
        },
        lookPhoto(type){
            this.$router.push({
                path: "/reservationPhoto",
                query:{
                    order_no:this.$route.query.order_no,
                    type:type
                }
            });
        },
        reservation(){ //预约流程
           this.$router.push({
                path: "/reservationHome",
                query:{
                    uuid:this.uuid,
                    templateFlag:this.$route.query.templateFlag,
                    gatCardFlag:this.gatCardFlag,
                    entity:this.$route.query.entity

                }
            });
        },
        telPhone(){
             this.openCall(this.hospital.phone)
        },
        cancel(){
          this.STATISTICS('click','sybao_ins_appointment_result_cancel_click')
          this.$alert({
            msg:'是否取消此次预约',
            cancelText:'我再想想',
            confirmText:'确定取消',
            closeBtn:true,  //是否展示右上角x号
            onCancel:()=>{
                console.log("取消的回调")
            },
            onConfirm:()=>{
                this.cancelBtn()
            }
        })
          
        },
        cancelBtn(){
            let data = {}
            if(this.gatCardFlag == process.env.VUE_APP_GAT_CARD){
                data = {
                    uuid:this.uuid
                }
                couponCancel(data).then(data=>{
                    this.progress()
                }).catch(err => {
                    this.$toast(err.message);
                })
            }else{
                data = { uuid:this.uuid }

                cancel(data).then(data=>{
                    this.progress()
                }).catch(err =>{
                    this.$toast(err.message);
                })
            }
           
            
        },
        progress(){
            let data = {
                    order_no:this.$route.query.order_no
                }
            // if(this.gatCardFlag == process.env.VUE_APP_GAT_CARD){
            //     data = {
            //         order_no:this.$route.query.order_no
            //     }
            // }else{
            //     data = { uuid:this.uuid }
            // }
            progress(data).then(data=>{
                // let a = getMyDate(data.patient)
                data.patient.appointment_time = getMyDate(data.patient.appointment_time * 1000)
                if(data.status == 10){
                    this.title = this.status_title = '预约成功'
                }
                if(data.status == 20){
                    this.title = this.status_title = '预约取消'
                }
                if(data.status == 30){
                    this.title = this.status_title = '预约成功'
                    this.title = this.status_title_last = '已完成'
                
                }
                if(data.status == 50){
                    this.title = this.status_title = '预约成功'
                    this.title = this.status_title_last = '已爽约'
                }
                this.info=data
             
                this.hospital = data.hospital
                this.patient = data.patient

            })
        },
    },
}
